import PropTypes from 'prop-types'

import { Star } from '../../public/static/svgs/Star'
import { WidgetContainer } from './styles'

export const StarWidget = ({
  starsCount, className, onPress, filled
}) => (
  <WidgetContainer className={className}>
    <button onClick={onPress}>
      <Star className="starSvg" filled={filled} />
    </button>
    <span className="starsCount">
      {starsCount}
    </span>
  </WidgetContainer>
)

StarWidget.propTypes = {
  starsCount: PropTypes.number.isRequired,
  onPress: PropTypes.func.isRequired,
  className: PropTypes.string,
  filled: PropTypes.bool
}

StarWidget.defaultProps = {
  className: undefined,
  filled: false
}
